import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {t, withState} from 'shared/core';
import {Layout, Panel, Display, Tag, EmployeeNameWithAvatar, DownloadLink} from 'shared/components';
import {Table} from 'main/components';
import {ExpenseRequestDetailsState} from '../state';
import ActionNotes from './ActionNotes';
import ActionButtons from './ActionButtons';
import RequestSummary from './RequestSummary';

const STATUS_COLOURS = {
  pending: 'sun',
  approved: 'grass',
  rejected: 'scarlet'
};

const EXPENSE_COLUMNS = [
  {
    header: 'expenses.expense_requests.detail.Title',
    render: model => model.totalRow ? <span className='medium'>{model.title}</span> : model.title,
    width: 3
  },
  {
    header: 'expenses.expense_requests.detail.Amount',
    render: model => model.totalRow ? <span className='medium'>{model.amountView}</span> : model.amountView,
    width: 2
  },
  {
    header: 'expenses.expense_requests.detail.Category',
    attribute: 'category',
    width: 2
  },
  {
    header: 'expenses.expense_requests.detail.Date',
    attribute: 'dateView',
    width: 2
  },
  {
    header: 'expenses.expense_requests.detail.Note',
    attribute: 'note',
    width: 3
  },
  {
    header: 'expenses.expense_requests.detail.Receipts',
    render: ({receipts}) => <Receipts receipts={receipts} />,
    width: 2
  }
];

const Receipts = observer(({receipts = []}) => {
  return (
    <div>
      {receipts.map(receipt => (
        <div key={receipt.id}>
          <DownloadLink
            href={receipt.link('url')}
            title={receipt.fileName}
          />
        </div>
      ))}
    </div>
  );
});

const ExpenseRequestDetailsContainer = observer(({uiState}) => {
  const {request, backButtonDetails} = uiState;
  const {backTitle} = backButtonDetails;

  return (
    <div>
      <Display
        documentTitle={request.title}
        title={
          <div className='flex align-items-center gap-2'>
            <span>{request.title}</span>
            <Tag colour={STATUS_COLOURS[request.status]}>
              <FormattedMessage id={`expenses.status.${request.status}`}/>
            </Tag>
          </div>
        }
        backTitle={backTitle}
        onBackClick={() => uiState.goBack()}
      />
      <Layout>
        <Layout.Section>
          <Panel>
            <RequestSummary uiState={uiState}/>
            <div className='mt2'>{request.description}</div>
            <Panel.Separator className='mt3'/>
            <Panel.Subheader title={t('expenses.expense_requests.detail.Expenses')}/>
            <Table
              horizontalScroll
              columns={EXPENSE_COLUMNS}
              models={[
                ...request.expenses,
                {
                  title: t('expenses.expense_requests.detail.Total'),
                  amountView: request.amountView,
                  totalRow: true
                }
              ]}
              showLinks={false}
            />
            {request.canAction && <ActionNotes uiState={uiState}/>}
            {request.actionedAt && <div>
              <Panel.Separator className='mt3' />
              <EmployeeNameWithAvatar
                employee={request.actionedByUser}
                details={t(`expenses.expense_requests.detail.actioned_at.${request.status}`, {date: request.actionedAtView})}
              />
              {request.actionedNotes && <div className='mt2'>{request.actionedNotes}</div>}
            </div>}
          </Panel>
          {request.canAction && <ActionButtons uiState={uiState} />}
        </Layout.Section>
      </Layout>
    </div>
  );
});

export default withState(ExpenseRequestDetailsContainer, ExpenseRequestDetailsState);
